import React, { useRef, useState } from 'react';
import { Box, Typography, Divider, Grid, Button,  } from '@mui/material';
import telengana_logo from '../../assets/telengana_logo.png';
import sign from '../../assets/signature.png';
import { saveAs } from 'file-saver';
import mammoth from 'mammoth';

import {
  Document,
  ImageRun,
  TextRun,
  TableRow,
  TableCell,
  WidthType,
  AlignmentType,
  Paragraph,
  Packer, Table, BorderStyle
} from 'docx';
import * as pdfjsLib from 'pdfjs-dist';
import 'pdfjs-dist/build/pdf.worker.entry';


const JMNotice = ({ formData }) => {
  const [formDataState] = useState(formData || {});
    const [uploadedDocContent, setUploadedDocContent] = useState('');
const [uploadedPdfText, setUploadedPdfText] = useState('');
const [pdfPages, setPdfPages] = useState([]);
const canvasContainerRef = useRef(null);

  const printRef = useRef();
  console.log('formDataState', formDataState);
  const {
    fileNumber,
    receivedDate,
    memoNumber,
    subject,
    applicantName,
    nextDateOfHearing,
    receiveFrom,
    managementAddress,
    managementMail,
    managementPhoneNumber,
    applicantAddress,
    applicantPhoneNumber,
    applicantMail,
    managementName
  } = formDataState;

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const options = {  day: 'numeric',  month: 'numeric',year: 'numeric', };
    return new Date(dateString).toLocaleDateString('en-IN', options);
  };

  const handlePrint = () => {
    window.print();
  };
const today = new Date();

const [signatureBase64, setSignatureBase64] = useState(null);
const [logobase64, setlogoBase64] = useState(null)

  React.useEffect(() => {
    // Convert signature image to base64 when component mounts
    getImageBase64(sign).then(setSignatureBase64);
        getImageBase64(telengana_logo).then(setlogoBase64);

  }, []);

  // The getImageBase64 function (defined inside or outside component)
const getImageBase64 = (url) =>
  fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64 = reader.result.split(',')[1];
            resolve(base64);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
    
const handlePdfUpload = async (event) => {
  const file = event.target.files[0];
  if (file && file.type === 'application/pdf') {
    const fileReader = new FileReader();
    fileReader.onload = async function () {
      const typedarray = new Uint8Array(this.result);
      const pdf = await pdfjsLib.getDocument({ data: typedarray }).promise;

      const pages = [];
      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);

        const viewport = page.getViewport({ scale: 1.5 });

        const canvas = document.createElement('canvas');
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        const context = canvas.getContext('2d');
        await page.render({ canvasContext: context, viewport }).promise;

        pages.push(canvas.toDataURL()); // Save canvas image
      }

      setPdfPages(pages);
    };
    fileReader.readAsArrayBuffer(file);
  }
};

   const handleDocxUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        const arrayBuffer = event.target.result;
        const result = await mammoth.convertToHtml({ arrayBuffer });
        setUploadedDocContent(result.value); // HTML string
      };
      reader.readAsArrayBuffer(file);
    }
  };




const generateDocx = async () => {
  if (!signatureBase64) {
    alert('Please wait, loading signature...');
    return;
  }

  const doc = new Document({
    sections: [
      {
        children: [
           new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            borders: {
              top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
              bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
              left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
              right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
              insideHorizontal: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
              insideVertical: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
            },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    children: [
                      new Paragraph({
                        children: [
                          new ImageRun({
                            data: logobase64,
                            transformation: { width: 80, height: 80 },
                          }),
                        ],
                        alignment: AlignmentType.LEFT,
                      }),
                    ],
                  }),
                  new TableCell({
                    width: { size: 80, type: WidthType.PERCENTAGE },
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: 'GOVERNMENT OF TELANGANA',
                            bold: true,
                            size: 28,
                          }),
                        ],
                        alignment: AlignmentType.LEFT,
                        spacing: { before: 200 },
                      }),
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: 'LABOUR DEPARTMENT',
                            size: 24,
                          }),
                        ],
                        alignment: AlignmentType.LEFT,
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),

                    new Paragraph({ text: '' }),
                  new Table({
  width: { size: 100, type: WidthType.PERCENTAGE },
  borders: {
    top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
    bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
    left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
    right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
    insideHorizontal: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
    insideVertical: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
  },
  rows: [
    new TableRow({
      children: [
        new TableCell({
          width: { size: 50, type: WidthType.PERCENTAGE },
          children: [
            new Paragraph({
              children: [
                new TextRun({ text: `File No: ${fileNumber || '-'}`, size: 24 }),
              ],
            }),
          ],
        }),
        new TableCell({
          width: { size: 50, type: WidthType.PERCENTAGE },
          children: [
            new Paragraph({
              alignment: AlignmentType.RIGHT,
              children: [
                new TextRun({ text: `Date: ${formatDate(today)}`, size: 24 }),
              ],
            }),
          ],
        }),
      ],
    }),
  ],
}),

                    new Paragraph({ text: '' }),

                    // Side by side: From (left) and Signature block (right)
                    new Table({
                      width: { size: 100, type: WidthType.PERCENTAGE },
                borders: {
                  top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                  bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                  left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                  right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                  insideHorizontal: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                  insideVertical: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                },
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        width: { size: 50, type: WidthType.PERCENTAGE },
                        borders: {},
                        children: [
                          new Paragraph({ children: [new TextRun({ text: 'From', bold: true })] }),
                          new Paragraph('A. SATYANARAYANA REDDY'),
                          new Paragraph('Asst. Commissioner of Labour,'),
                          new Paragraph('Ranga Reddy District,'),
                          new Paragraph('Ph# 9492555253.'),
                        ],
                      }),
                      new TableCell({
                        width: { size: 50, type: WidthType.PERCENTAGE },
                        borders: {},
                        children: [
                          new Paragraph({ children: [new TextRun({ text: 'To', bold: true })] }),
                          new Paragraph(managementName || '-'),
                          new Paragraph(managementAddress || '-'),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
          new Paragraph({ text: '' }),
          new Paragraph({
            text: `Sub : ${subject || '-'}`,
            bold: true,
          }),
          new Paragraph({
            text: `Ref : Memo No ${memoNumber || '-'} and Received from ${receiveFrom || '-'}`,
            bold: true,
          }),
          new Paragraph(`Application Dated ${formatDate(receivedDate)} of ${applicantName || '-'}`),
          new Paragraph({ text: '' }),
          new Paragraph({
            text: '*****',
            alignment: AlignmentType.CENTER,
          }),
          new Paragraph({ text: '' }),
          new Paragraph(
            `This is to inform you that a joint meeting has been scheduled at the office of the Assistant Commissioner of Labour, Rangareddy, located at T. Anjaiah Karmika Sankshema Bhavan, RTC-X-Road, Hyderabad, on ${formatDate(nextDateOfHearing)}, at 11:00 AM. The purpose of the meeting is to address and resolve the issues raised by ${applicantName} with the management (copy of the representation enclosed).`
          ),
          new Paragraph(
            'Both parties are hereby directed to attend the meeting in person, without fail, to facilitate an amicable resolution of the matter. The management is further instructed to bring all relevant registers and records, along with a written response to the representation, and ensure that an authorised representative is present at the meeting.'
          ),
          new Paragraph(
            'Your strict compliance with this notice is expected. Failure to attend or provide the necessary documentation may result in appropriate action under the applicable labour laws.'
          ),
          new Paragraph({ text: '' }),
          // Signature image aligned right
          new Paragraph({
            alignment: AlignmentType.RIGHT,
            children: [
              new ImageRun({
                data: signatureBase64,
                transformation: { width: 120, height: 50 },
              }),
            ],
          }),
          // Designation text aligned directly under the image
          new Paragraph({
            alignment: AlignmentType.RIGHT,
            children: [
              new TextRun({ text: 'Asst. Commissioner of Labour', bold: true }),
            ],
          }),
          new Paragraph({
            alignment: AlignmentType.RIGHT,
            children: [
              new TextRun({ text: 'Rangareddy', bold: true }),
            ],
          }),

          new Paragraph({ text: '' }),
          new Paragraph(`Copy to ${applicantName} attend a Joint meeting on the above-said date and time.`),
        ],
      },
    ],
  });

  const blob = await Packer.toBlob(doc);
  saveAs(blob, `Notice_${fileNumber || 'unknown'}.docx`);
};


  return (
    <Box >
      {/* Print Button (Hidden in Print) */}
      
     <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mb: 2,
          gap: 2,
          '@media print': {
            display: 'none',
          },
        }}
      >
        <Button variant="contained" color="primary" onClick={handlePrint} style={{textTransform:'none', fontFamily:'poppins'}}>
          Print Notice
        </Button>
        <Button variant="outlined" color="secondary" onClick={generateDocx} style={{textTransform:'none', fontFamily:'poppins'}}>
          Download DOCX
        </Button>
      </Box>

    <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              mb: 2,
              '@media print': {
                display: 'none',
              },
            }}
          >
            <Button
      variant="outlined"
      component="label"
      style={{ textTransform: 'none', fontFamily: 'poppins' }}
    >
      Upload PDF Annexure
      <input type="file" hidden accept="application/pdf" onChange={handlePdfUpload} />
    </Button>
     <Button
          variant="outlined"
          component="label"
          style={{ textTransform: 'none', fontFamily: 'poppins' }}
        >
          Upload Word Annexure
          <input type="file" hidden accept=".docx" onChange={handleDocxUpload} />
        </Button>
      </Box>

      {/* Printable Content */}
      <Box
        ref={printRef}
        padding={3}
        sx={{
          fontFamily: 'Arial, sans-serif',
          lineHeight: 1.5,
          margin: '0 auto',
          backgroundColor: 'white',
          color: 'black',
          boxShadow: '0 0 10px rgba(0,0,0,0.1)',
          '@media print': {
            boxShadow: 'none',
            margin:0,
            maxWidth: '100%',
          },
        }}
      >
        {/* Header */}
   <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
  <Box mr={2}>
    <img src={telengana_logo} alt="Telangana Logo" width="90" />
  </Box>
  <Box>
    <Typography variant="h5" fontWeight="bold">
      GOVERNMENT OF TELANGANA
    </Typography>
    <Typography variant="h6" fontWeight="bold">
      LABOUR DEPARTMENT
    </Typography>
  </Box>
</Box>

        {/* File No and Date */}
        <Box display="flex" justifyContent="space-between" mt={2}>
          <Typography variant="body1" style={{ fontSize: 18 }}>
            <strong>File No:</strong> {fileNumber || '-'}
          </Typography>
          <Typography variant="body1" style={{ fontSize: 18, marginRight:80 }}>
            <strong>Date:</strong> {formatDate(today)}
          </Typography>
        </Box>

        {/* From and To */}
        <Grid container mt={1}>
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold">
              From
            </Typography>
            <Typography variant="body1">A. SATYANARAYANA REDDY</Typography>
            <Typography variant="body1">Asst. Commissioner of Labour,</Typography>
            <Typography variant="body1">Ranga Reddy District,</Typography>
            <Typography variant="body1">Ph# 9492555253.</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold">
              To
            </Typography>
            <Typography variant="body1">{managementName || '-'}</Typography>
            <Typography variant="body1">{managementAddress || '-'}</Typography>
          </Grid>
        </Grid>

        {/* Subject and Reference */}
<Box mt={1} ml={4}>
  {/* Subject */}
  <Box display="flex" alignItems="flex-start" mb={1}>
    <Box sx={{ minWidth: '3rem', fontSize: 15, fontWeight: 'bold' }}>Sub:</Box>
    <Typography variant="body1" textAlign="justify" sx={{ fontSize: 14 }}>
      {subject || '-'}
    </Typography>
  </Box>

  {/* Ref: Memo No. */}
  {(memoNumber && receiveFrom) && (
    <>
      <Box display="flex" alignItems="flex-start" mt={1}>
        <Box sx={{ minWidth: '3rem', fontSize: 15, fontWeight: 'bold' }}>Ref:</Box>
        <Typography variant="body1" textAlign="justify" sx={{ fontSize: 14 }}>
          1. Memo No. {memoNumber} of {receiveFrom} Dated {formatDate(receivedDate)}
        </Typography>
      </Box>

      {(receivedDate || applicantName) && (
        <Box display="flex" alignItems="flex-start" mt={1}>
          <Box sx={{ minWidth: '3rem' }} />
          <Typography variant="body1" textAlign="justify" sx={{ fontSize: 14 }}>
            2. Application Dated {formatDate(receivedDate)} of {applicantName || '-'}
          </Typography>
        </Box>
      )}
    </>
  )}

  {/* Only Application Date (or with applicantName) - Show Ref: 1. Application Dated... */}
  {(!memoNumber || !receiveFrom) && (receivedDate || applicantName) && (
    <Box display="flex" alignItems="flex-start" mt={1}>
      <Box sx={{ minWidth: '3rem', fontSize: 15, fontWeight: 'bold' }}>Ref:</Box>
      <Typography variant="body1" textAlign="justify" sx={{ fontSize: 14 }}>
        1. Application Dated {formatDate(receivedDate)}{applicantName && ` of ${applicantName}`}
      </Typography>
    </Box>
  )}
</Box>



        {/* Main Content */}
        <Box mt={1} textAlign="center">
          <Typography variant="h6" fontWeight="bold">*****</Typography>
        </Box>

        <Box>
            <Typography variant="body1" paragraph sx={{ textAlign: 'justify', fontSize: 13, textIndent: '6em'}}>
              This is to inform you that a joint meeting has been scheduled at the office of the Assistant Commissioner of Labour, Rangareddy, located at T. Anjaiah Karmika Sankshema Bhavan, RTC-X-Road, Hyderabad, on <strong>{formatDate(nextDateOfHearing)}</strong>, at <strong>11:00 AM</strong>.
              The purpose of the meeting is to address and resolve the issues raised by <strong>{applicantName}</strong> with the management (copy of the representation enclosed).
            </Typography>

          <Typography variant="body1" paragraph sx={{ textAlign: 'justify', fontSize: 13,textIndent: '6em' }}>
            Both parties are hereby directed to attend the meeting in person, without fail, to facilitate an amicable resolution of the matter. <strong style={{textDecoration:'underline'}}>The management is further instructed to bring all relevant registers and records, along with a written response to the representation, and ensure that an authorised representative is present at the meeting.</strong>
          </Typography>

          <Typography variant="body1" paragraph sx={{ textAlign: 'justify', fontSize: 13,textIndent: '6em' }}>
            Your strict compliance with this notice is expected. Failure to attend or provide the necessary documentation may result in appropriate action under the applicable labour laws.
          </Typography>
        </Box>

        {/* Signature Section */}
        <Box  textAlign="right">
          <img src={sign} alt="Signature" width="120" style={{ marginBottom: '5px',marginRight:20 }} />
          <Typography variant="body1" fontWeight="bold">
            Asst. Commissioner of Labour
          </Typography>
          <Typography variant="body1" fontWeight="bold">
            Rangareddy
          </Typography>
        </Box>
        <Box mt={1} >
          <Typography variant="body1">
            Copy to <strong>{applicantName}</strong> attend a Joint meeting on the above-said date and time.
          </Typography>
        </Box>
      </Box>
        {pdfPages.length > 0 && (
  <Box
    sx={{
      pageBreakBefore: 'always',
      mt: 4,
    }}
    ref={canvasContainerRef}
  >

    {pdfPages.map((imgSrc, index) => (
      <Box key={index} sx={{ mt: 2, pageBreakAfter: 'always' }}>
        <img
          src={imgSrc}
          alt={`PDF page ${index + 1}`}
          style={{ width: '100%', maxWidth: '800px', display: 'block', margin: '0 auto' }}
        />
      </Box>
    ))}
  </Box>
)}
  {uploadedDocContent && (
        <Box
          sx={{
            pageBreakBefore: 'always',
            breakBefore: 'page',
            mt: 4,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Annexure (Uploaded Word File)
          </Typography>
          <Box
            dangerouslySetInnerHTML={{ __html: uploadedDocContent }}
            sx={{ fontSize: 14, lineHeight: 1.6 }}
          />
        </Box>
      )}

    </Box>
  );
};

export default JMNotice;
